import { Injectable } from "@angular/core";
import { FeatureManagementServiceProxy } from "../service-proxies/service-proxies";
import { Observable } from "rxjs";


@Injectable()
export class FeatureManagerService {

    private _featureFlags: string[] = [];

    constructor(private _featureManagementService: FeatureManagementServiceProxy) {

    }

    /**
     * Indicates whether or not a feature is turned On
     * @param featureName
     */
    public featureOn(featureName: string) {
        return this._featureFlags && !!this._featureFlags.find(feature => feature === featureName);
    }

    /**
     *  Initializes the FeatureManagerService by retrieving the enabled features.
     * */
    public initialize(): Promise<void> {
        this._featureFlags = [];
        return new Promise<void>((resolve) => {
            this.getFeatureFlags()
                .subscribe(
                    featureFlags => {
                        this._featureFlags = featureFlags;
                        resolve(); // Explicitly pass undefined
                    },
                    (e) => {
                        console.error(e);
                        resolve(); // Explicitly pass undefined even if there's an error
                    }
                );
        });
    }

    private getFeatureFlags(): Observable<string[]> {
        return this._featureManagementService.getEnabledFeatures();
    }
}
